export default __webpack_public_path__ + "static/media/logo.7df8bbf7.png";